import React, { ReactNode, useRef, useEffect, useState } from 'react';
import SidebarComponent from '../Components/Navigation/SidebarComponent';
import { useLocation } from 'react-router-dom';
import { useNavigation } from '../Context/NavigationContext';
import { Menu } from 'react-feather';
import Logo2 from '../Assets/new-logo.png';

interface LayoutComponentProps {
  header: ReactNode | null;
  content: ReactNode | null;
}

const LayoutComponent: React.FC<LayoutComponentProps> = ({ header, content }) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const contentRef = useRef<HTMLDivElement>(null);
  const location = useLocation();
  const [isAnimating, setIsAnimating] = useState(false);
  const { isMobile, toggleMobileSidebar } = useNavigation();

  // Trigger animation on route change
  useEffect(() => {
    setIsAnimating(true);
    const timer = setTimeout(() => setIsAnimating(false), 300);
    return () => clearTimeout(timer);
  }, [location.pathname]);

  return (
    <div className="h-screen w-screen flex flex-col md:flex-row overflow-hidden bg-dark-bg" ref={containerRef}>
      {/* Mobile Header */}
      {isMobile && (
        <div className="flex-shrink-0 flex items-center justify-between px-4 py-3 bg-dark-card border-b border-dark-border safe-area-top">
          <button
            onClick={toggleMobileSidebar}
            className="p-2 -ml-2 rounded-lg hover:bg-dark-card-hover active:bg-dark-card-hover transition-colors"
            aria-label="Open menu"
          >
            <Menu size={24} className="text-gray-300" />
          </button>
          <img src={Logo2} alt="Logo" className="h-7" />
          <div className="w-10" /> {/* Spacer for centering logo */}
        </div>
      )}

      <SidebarComponent />

      <div id="content" className="flex-1 h-full overflow-hidden min-w-0">
        <div ref={contentRef} className="flex flex-col h-full w-full">
          {header === null ? null : (
            <div className="w-full h-auto md:h-20 sticky top-0 z-20 px-2 md:px-4 pt-2 md:pt-3 flex-shrink-0">
              {header}
            </div>
          )}
          <div
            id="main-content"
            className={`flex-1 overflow-auto transition-all duration-300 ease-out ${
              isAnimating ? 'opacity-0 translate-y-2' : 'opacity-100 translate-y-0'
            }`}
          >
            {content}
          </div>
        </div>
      </div>
    </div>
  );
};

export default LayoutComponent;
